module.exports = __webpack_public_path__ + "img/failure_warmness_illustration.a6cf93c2.jpg";